<template>
  <Col class="dst mt-5 mb-5">
    <div class="control-row">
      <span
        class="dst-title fontweight mx-1"
        style="display: inline-block; width: 150px"
        >{{ myData.gamename }}</span
      >
      <span class="fontweight mx-1" style="display: inline-block; width: 130px">
        [
        <span class="green-text mx-1">{{
          myData.listPeriodData.lastperiod
        }}</span>
        ]
      </span>
      <span class="fontweight mx-1" style="display: inline-block; width: 210px"
        >距离封盘： {{ closetime || "已封盘" }}</span
      >
      <span class="fontweight mx-1" style="display: inline-block; width: 210px"
        >距离开奖： {{ sealtime || "已关盘" }}</span
      >
      <span class="mx-1">
        自动刷新
        <Select v-model="nowSecond" @on-change="reload" style="width: 70px">
          <Option v-for="item in reloadSecond" :value="item" :key="item">{{
            item
          }}</Option>
        </Select>
      </span>
      <span class="mx-1" style="display: inline-block; width: 30px"
        >{{ realtime }}秒</span
      >
      <Button
        v-if="authority == 1"
        class="mx-1"
        type="error"
        @click="ModalClick(1)"
      >
        <Icon type="md-add" />新增期数
      </Button>
    </div>
    <ModalSettingPeriod
      @now-modal-game="setNowGame"
      @reload="reload"
      :showModal.sync="showModal"
      :ModalData="ModalData"
      :ModalState="ModalState"
    />
    <Table
      class="lida-table mt-2 mb-2"
      :row-class-name="rowClassName"
      :columns="columns"
      :data="myData.markDataList"
    />
  </Col>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from 'vuex'
import defaulePeriod from '@/mixins/defaule-period.js'
export default {
  components: {
    ModalSettingPeriod: () => import("./ModalSettingPeriod")
  },
  mixins: [defaulePeriod],
  props: {
    columns: Array,
    data: Object,
    trStatus: Boolean
  },
  data () {
    return {
      nowModalGame: 0, // 现在modal是哪个游戏
      nowSecond: 60,
      reloadSecond: [60, 30, 10, 5],
      showModal: false,
      ModalState: null, // 新增:1, 修改:2
      ModalData: {}, // 预设要塞入的资料
      timeLoop: null, // 计时器
      closetime: null, // 距离封盘
      sealtime: null, // 距离开奖
      realtime: null, // 倒数中秒数
      interval: null, // 倒数计时器
      myData: {}
    };
  },
  computed: {
    ...mapGetters(['getpermission', 'loadTimes']),
    authority () {
      return this.getpermission.gameset[3]
    }
  },
  watch: {
    loadTimes () {
      this.reload()
    },
    "myData.listPeriodData.lastperiod" (newValue, oldValue) {
      // 期数变了 && newValue跟oldValue都有值 && 目前游戏的modal是打开的
      if (newValue && oldValue && this.showModal) {
        this.ModalClick(this.ModalState)
      }
    }
  },
  created () {
    if (this.authority == 0) this.columns.splice(this.columns.length - 1, 1)
    if (this.data) {
      this.myData = this.data
      this.nowSecond = this.checknowSecond(this.data.listPeriodData.betSeconds)
    }
    this.realtime = this.nowSecond;
    this.lotteryCount();
    this.timeRunning();
  },
  beforeDestroy () {
    clearTimeout(this.timeLoop);
    clearInterval(this.interval);
  },
  methods: {
    ModalClick (state, GPMId, period) {
      this.showModal = true;
      this.ModalState = state;
      let isNowPeriod = this.myData.listPeriodData.lastperiod == period
      this.ModalData = state === 1 ? this.myData : { ...this.myData, GPMId, isNowPeriod }
    },
    async reload () {
      const id = this.myData.gameid
      let defaultState = true // 是否加入預設期數
      try {
        this.realtime = this.nowSecond;
        let res = await this.$axios.gameLobby.GamePeriodMark(id);
        this.myData.listPeriodData = res[id].listPeriodData
        this.myData.markDataList = res[id].markDataList.map(item => {
          item.mark = item.mark.split(",");
          item.codate = moment(item.endate).subtract(15, 'seconds').format('YYYY-MM-DD HH:mm:ss')
          'second' in this.myData.listPeriodData
            ? item.second = this.myData.listPeriodData.second
            : null
          return item;
        })
        // 产出预设期数资料
        const defaultGameList = this.defaultPeriod(res[id], this.myData.gameGroupId)
        // 判断是否已有设定号码，预设存入预设期数 
        if (!this.myData.markDataList.some(it => it.period == Number(defaultGameList.period))) {
          res[id].markDataList.unshift(defaultGameList)
        }
        res[id].markDataList = res[id].markDataList.filter(this.filterTimeOut)
        Object.keys(res[id]).forEach(it => {
          this.myData[it] = res[id][it];
        });
      } catch (error) {
        console.error(error);
      }
    },
    timeRunning () {
      clearInterval(this.interval);
      const fun = () => {
        if (--this.realtime <= -1) {
          this.realtime = this.nowSecond;
          this.reload(this.data.gameid);
        }
      }
      fun()
      this.interval = setInterval(() => fun(), 1000);
    },
    lotteryCount () {
      this.timeText(-1);
      if (!this.myData.listPeriodData) return;
      clearTimeout(this.timeLoop);
      let callTime = () => {
        let now = moment(moment.tz('Asia/Hong_Kong').format("YYYY-MM-DD H:mm:ss")).valueOf();
        // let now = moment(moment().format("YYYY-MM-DD H:mm:ss")).valueOf();
        let clo = moment(
          new Date(this.myData.listPeriodData.lastcodate)
        ).valueOf();
        let seal = moment(
          new Date(this.myData.listPeriodData.lastendate)
        ).valueOf();
        let subTime1 = moment.tz(clo - now, "Africa/Abidjan");
        let subTime2 = moment.tz(seal - now, "Africa/Abidjan");
        this.closetime = this.timeText(subTime1, '已封盘');
        this.sealtime = this.timeText(subTime2);
      }
      callTime()
      this.timeLoop = setInterval(() => {
        callTime()
      }, 1000);
    },
    setNowGame (val) { // 目前开始哪个游戏的modal
      this.nowModalGame = val
    },
    timeText (date, resultText = "已关盘") {
      if (date < 0) return resultText;
      const time = val => {
        return val < 10 ? `0${val}` : val;
      };
      const h = time(date.get("hours"));
      const m = time(date.get("minutes"));
      const s = time(date.get("seconds"));
      return `${h}小时 ${m}分钟 ${s}秒`;
    },
    rowClassName (row, index) {
      if (index === 0 && this.trStatus) {
        return "demo-table-info-row";
      }
      return "";
    },
    checknowSecond (val) { // 判斷開獎時間，取得幾秒刷新的時間
      if (val <= 75) {
        return 10
      } else if (val <= 600) {
        return 30
      } else {
        return 60
      }
    }
  }
};
</script>

<style lang="scss">
.dst {
  .lida-table {
    .ivu-table-header thead tr th {
      padding: 4px 0;
    }
  }
  .dst-title {
    font-size: 21px;
    color: #515a6e;
  }
}
.ivu-table .demo-table-info-row td {
  background-color: #dfdfdf;
}
.del-disable {
  color: #ffffff;
  background-color: #e6907a;
  border-color: #e6907a;
}
</style>